import { Button } from '@/components/ui';
import { HeaderSize, HeaderText } from '@/components/ui/HeaderText';
import { useRouter } from '@/navigation';
import React from 'react';

type UpsellCardProps = {
  headerText: string;
  subText: React.ReactNode;
  ctaText: string;
  ctaLink: string;
  children?: React.ReactNode;
  onClick?: () => void;
};

const UpsellCard: React.FC<UpsellCardProps> = ({
  headerText,
  subText,
  ctaText,
  ctaLink,
  children,
  onClick,
}) => {
  const { push } = useRouter();
  const handleClick = () => {
    onClick && onClick();
    push(ctaLink);
  };

  return (
    <div className="rounded-md p-6 mb-10 shadow-lg flex md:flex-row flex-col gap-4 md:items-center">
      <div className="basis-3/5">
        <HeaderText
          classes="text-3xl md:text-4xl pb-2"
          size={HeaderSize.H3}
          align="left"
          text={headerText}
        />

        {subText && <div className="text-left md:pr-3">{subText}</div>}
      </div>
      <Button
        classes="basis-2/5"
        ctaText={ctaText}
        onClick={() => handleClick()}
      />
      {children && children}
    </div>
  );
};
export default UpsellCard;
